module.exports = __webpack_public_path__ + "static/img/icon-safe6.2805eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-safe6.png
// module id = XpyD
// module chunks = 21